import { utils } from '@ps/web-poker-tile-mappers';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { FilterOptionBuyIn } from '@swf/poker';

import { FILTER_RANGE_MULTIPLIER } from '../../../constants';
import { usePokerMultiTableTournamentsWidget } from '../../../model';
import { getBuyInFilterVariableMap } from '../../../utils/filters';

interface Props {
  optionValue: Exclude<FilterOptionBuyIn, FilterOptionBuyIn.Custom | FilterOptionBuyIn.Starscoin>;
}

const BuyInDescription: React.FC<Props> = ({ optionValue }) => {
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const playMode = useSelector(select.currency.getPlayMode);
  const { widgetSelect } = usePokerMultiTableTournamentsWidget();
  const currency = useSelector(widgetSelect.getTournamentsCurrency);
  const { minimum, maximum } = getBuyInFilterVariableMap(optionValue, playMode);
  let formattedMinimum = `${minimum / FILTER_RANGE_MULTIPLIER}`;
  let formattedMaximum = `${maximum / FILTER_RANGE_MULTIPLIER}`;

  if (currency !== 'MULTIPLE') {
    formattedMinimum = utils.formatCurrency(minimum, currency, {
      separators: true,
      isPlayMoney: isPlayMoney ? 1 : 0,
      scalePM: 0
    });

    formattedMaximum = utils.formatCurrency(maximum, currency, {
      separators: true,
      isPlayMoney: isPlayMoney ? 1 : 0,
      scalePM: 0
    });
  }

  let description;
  switch (optionValue) {
    case FilterOptionBuyIn.Micro:
      description = <>&lt;&nbsp;{formattedMaximum}</>;
      break;
    case FilterOptionBuyIn.Low: {
      if (isPlayMoney) {
        description = <>&lt;&nbsp;{formattedMaximum}</>;
      } else {
        description = (
          <>
            {formattedMinimum}&nbsp;-&nbsp;{formattedMaximum}
          </>
        );
      }
      break;
    }
    case FilterOptionBuyIn.Medium:
      description = (
        <>
          {formattedMinimum}&nbsp;-&nbsp;{formattedMaximum}
        </>
      );
      break;
    case FilterOptionBuyIn.High:
      description = <>{formattedMinimum}+</>;
      break;
  }

  return <span>{description}</span>;
};

export default BuyInDescription;
